module.exports = __webpack_public_path__ + "img/honey_white.7f7f66b3.svg";